<template>
    <v-img
        :src="getImageSource()"
        :aspect-ratio="aspectRatio"
        :max-height="maxHeight"
        :max-width="maxWidth"
        :position="position"
        :contain="contain"
    >
        <slot />
    </v-img>
</template>

<script>
export default {
    props: {
        srcWithoutFileType: String,
        availableFileTypes: Array,
        aspectRatio: Number,
        maxHeight: [String, Number],
        maxWidth: [String, Number],
        position: String,
        fillMode: String,
        src: [Object, String],
        noAutoSizing: Boolean,
        contain: Boolean
    },
    data: () => ({
        supportsWebp: true
    }),
    mounted() {
        var img = new Image();
        img.onload = function() {
            this.supportsWebp = !!(img.height > 0 && img.width > 0);
        };
        img.onerror = function() {
            this.supportsWebp = false;
        };
        img.src = require("@/assets/img/webp_check.webp");
    },
    methods: {
        getImageSource() {
            let def_src = this.srcWithoutFileType;

            if(this.$vuetify.breakpoint.mdOnly && !this.noAutoSizing) {
                def_src += "-md";
            } else if(this.$vuetify.breakpoint.lgAndUp && !this.noAutoSizing) {
                def_src += "-lg";
            }

            if(this.supportsWebp && this.availableFileTypes.find(x => x === "webp")) {
                def_src += ".webp";
            } else {
                def_src += "." + this.availableFileTypes.find(x => x !== 'webp');
            }

            

            return require("@/assets/img/" + def_src);
        }
    }
}
</script>